module.exports = "https://cdn.hellotech.com/client-assets/routers_tablet_db37c8bf96a508c18f1ceb8d663b5d3d.png";